import { MaterialWorking, LabourWorking } from "./interfaces"
import axios from 'axios'

const apiURL = process.env.REACT_APP_API_URL

const getAuthHeaders = () => {
  const token = localStorage.getItem('authToken')
  if (!token) {
    throw new Error('Authorization token not found')
  }
  return {
    'Content-Type': 'application/json',
    Authorization: 'Bearer ' + token,
  }
}

// Material Working API functions
export const getMaterialWorkingsByEnquiry = async (enquiryId: number): Promise<MaterialWorking[]> => {
  const response = await axios.get(
    `https://${apiURL}/MaterialWorking/enquiry/${enquiryId}`,
    { headers: getAuthHeaders() }
  )
  return response.data
}

export const getMaterialWorkingsByJob = async (jobId: number): Promise<MaterialWorking[]> => {
  const response = await axios.get(
    `https://${apiURL}/MaterialWorking/job/${jobId}`,
    { headers: getAuthHeaders() }
  )
  return response.data
}

export const getMaterialWorkingsByQuote = async (quoteId: number): Promise<MaterialWorking[]> => {
  const response = await axios.get(
    `https://${apiURL}/MaterialWorking/quote/${quoteId}`,
    { headers: getAuthHeaders() }
  )
  return response.data
}

export const getMaterialWorkingById = async (id: number): Promise<MaterialWorking> => {
  const response = await axios.get(
    `https://${apiURL}/MaterialWorking/${id}`,
    { headers: getAuthHeaders() }
  )
  return response.data
}

export const createMaterialWorking = async (materialWorking: MaterialWorking): Promise<MaterialWorking> => {
  const response = await axios.post(
    `https://${apiURL}/MaterialWorking`,
    materialWorking,
    { headers: getAuthHeaders() }
  )
  return response.data
}

export const updateMaterialWorking = async (id: number, materialWorking: MaterialWorking): Promise<MaterialWorking> => {
  const response = await axios.put(
    `https://${apiURL}/MaterialWorking/${id}`,
    materialWorking,
    { headers: getAuthHeaders() }
  )
  return response.data
}

export const deleteMaterialWorking = async (id: number): Promise<void> => {
  await axios.delete(
    `https://${apiURL}/MaterialWorking/${id}`,
    { headers: getAuthHeaders() }
  )
}

// Labour Working API functions
export const getLabourWorkingsByEnquiry = async (enquiryId: number): Promise<LabourWorking[]> => {
  const response = await axios.get(
    `https://${apiURL}/LabourWorking/enquiry/${enquiryId}`,
    { headers: getAuthHeaders() }
  )
  return response.data
}

export const getLabourWorkingsByJob = async (jobId: number): Promise<LabourWorking[]> => {
  const response = await axios.get(
    `https://${apiURL}/LabourWorking/job/${jobId}`,
    { headers: getAuthHeaders() }
  )
  return response.data
}

export const getLabourWorkingsByQuote = async (quoteId: number): Promise<LabourWorking[]> => {
  const response = await axios.get(
    `https://${apiURL}/LabourWorking/quote/${quoteId}`,
    { headers: getAuthHeaders() }
  )
  return response.data
}

export const getLabourWorkingById = async (id: number): Promise<LabourWorking> => {
  const response = await axios.get(
    `https://${apiURL}/LabourWorking/${id}`,
    { headers: getAuthHeaders() }
  )
  return response.data
}

export const createLabourWorking = async (labourWorking: LabourWorking): Promise<LabourWorking> => {
  const response = await axios.post(
    `https://${apiURL}/LabourWorking`,
    labourWorking,
    { headers: getAuthHeaders() }
  )
  return response.data
}

export const updateLabourWorking = async (id: number, labourWorking: LabourWorking): Promise<LabourWorking> => {
  const response = await axios.put(
    `https://${apiURL}/LabourWorking/${id}`,
    labourWorking,
    { headers: getAuthHeaders() }
  )
  return response.data
}

export const deleteLabourWorking = async (id: number): Promise<void> => {
  await axios.delete(
    `https://${apiURL}/LabourWorking/${id}`,
    { headers: getAuthHeaders() }
  )
}